import classnames from 'classnames';
import { createElement } from 'react';
import './style/index.less';
List.defaultProps = {
    prefixCls: 'im-list-wrap',
    hideLine: true,
};
function List(props) {
    const { prefixCls, children, className, style, type, renderHeader, renderFooter, hideLine, row, ...restProps } = props;
    const wrapCls = classnames(prefixCls, className);
    return (createElement("div", Object.assign({ className: wrapCls, style: style }, restProps),
        renderHeader ? (createElement("div", { className: `${prefixCls}-header` }, typeof renderHeader === 'function' ? renderHeader() : renderHeader)) : null,
        children ? (createElement("div", { className: hideLine ? `${prefixCls}-body-hide-line` : `${prefixCls}-body`, style: row ? type == 'card' ? { display: 'flex', flexDirection: 'row', flexWrap: 'wrap' } : { display: 'flex', flexDirection: 'row' } : {} }, children)) : null,
        renderFooter ? (createElement("div", { className: `${prefixCls}-footer` }, typeof renderFooter === 'function' ? renderFooter() : renderFooter)) : null));
}
export default List;
